import Model from "./base/model";

class SolicitationStatus extends Model{
  resourceName() {
    return "solicitation_status";
  }

  fields() {
    return {
      name: "",
      description: ""
    };
  }
}

export default new SolicitationStatus();
